export class OrderMessage {
	date: string;
	type: string;
	internalMessage: string;
	publicMessage: string;
}



// WEBPACK FOOTER //
// ./src/app/models/order-message.model.ts